import { render, staticRenderFns } from "./NotificationsCountBadge.vue?vue&type=template&id=5cc68f97"
import script from "./NotificationsCountBadge.vue?vue&type=script&lang=js"
export * from "./NotificationsCountBadge.vue?vue&type=script&lang=js"
import style0 from "./NotificationsCountBadge.vue?vue&type=style&index=0&id=5cc68f97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports